// extracted by css-extract-rspack-plugin
export default {"mapButtonContainer":"MapToggleButton-module__mapButtonContainer","mapButton":"MapToggleButton-module__mapButton","buttonText":"MapToggleButton-module__buttonText"};